module.exports = __webpack_public_path__ + "assets/img/226401.24961928.png";